import { getUrlParams, safeReadParams } from "../../../helper";
import { ROOT_PARENT } from "./dragUtils";

export function getInitialParentId(props) {
	const routeParentId = safeReadParams(props, "parentId");
	if (routeParentId) {
		return routeParentId;
	}

	if (safeReadParams(props, "infoId")) {
		return ROOT_PARENT;
	}

	const queryParentId = getUrlParams().parentId;
	return queryParentId ? decodeURIComponent(queryParentId) : ROOT_PARENT;
}
